import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation UnitEnable($uid: String!){
        unit_enable (uid: $uid) {
            success
        }
    }
`;

export async function unitEnable(uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ unit_enable: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.unit_enable;
}
